import { Component, Input } from '@angular/core';
import { OfferCustomFieldValueDto } from '@core/services/dto';

@Component({
  selector: 'app-custom-field-values',
  templateUrl: './custom-field-values.component.html',
  styleUrls: ['./custom-field-values.component.scss'],
})
export class CustomFieldValuesComponent {
  @Input() values: OfferCustomFieldValueDto[] | string | Record<string, string | number> = [];
  @Input() variant: 'modal' | 'page' = 'modal';

  get visibleValues(): OfferCustomFieldValueDto[] {
    const values = this.normalizeValues().map((item) => ({
      ...item,
      displayLabel: item.displayLabel || item.fieldName,
      value: item.value ?? item.fieldValue,
    })).filter((item) => !!item.displayLabel && item.value !== null && item.value !== undefined && String(item.value).trim() !== '')
      .sort((left, right) => (left.sequence || 0) - (right.sequence || 0));
    return values;
  }

  isVisible(): boolean { return this.visibleValues.length > 0; }

  formatValue(value: string | number, label?: string): string {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {return String(value);}
    const formattedValue = numericValue.toLocaleString('en-US', { maximumFractionDigits: 2 });
    if (label?.toLowerCase().includes('amount')) {return `$ ${formattedValue}`;}
    if (label?.toLowerCase().includes('rate')) {return `${formattedValue} %`;}
    return formattedValue;
  }

  private normalizeValues(): OfferCustomFieldValueDto[] {
    if (!this.values) {return [];}
    let fields = this.values;
    if (typeof fields === 'string') {
      try {
        fields = JSON.parse(fields);
      } catch {
        return [];
      }
    }
    if (Array.isArray(fields)) {return fields;}
    return Object.entries(fields).map(([displayLabel, value], index) => ({
      displayLabel,
      value,
      sequence: index + 1,
    }));
  }
}
